import type { CreativeType } from '../../../../../configs/creativeTypes';
import { INTERCHANGEABLE_CREATIVE_TYPE_GROUPS, SUPPORTED_CREATIVE_TYPES } from '../constants';

export const isSupportedCreativeType = (type: CreativeType): boolean => SUPPORTED_CREATIVE_TYPES.includes(type);

/** Original creative type first, then interchangeable alternatives for line-item resolution. */
export const getResolvableCreativeTypes = (creativeType: CreativeType): CreativeType[] => {
  const interchangeableGroup = INTERCHANGEABLE_CREATIVE_TYPE_GROUPS.find((group) => group.includes(creativeType));

  if (!interchangeableGroup) {
    return [creativeType];
  }

  return [creativeType, ...interchangeableGroup.filter((type) => type !== creativeType)];
};
